<template>
    <v-container>
        <v-layout>
            <v-flex xs12>
                <Categories></Categories>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import Categories from "../../components/category/Categories.vue";

export default {
    components: {
        Categories
    },
    props: [
        
    ],
    data() {
        return {
            
        };
    },
    computed: {
        
    },
    methods: {
        
    }
};
</script>

<style>

</style>
